import classes from "./InputElement.module.css";
import { useRef } from "react";

export function InputElement({
  labelText,
  onChange,
  id,
  disabled,
  onFocus,
  value,
  name,
  style = {},
  readOnly = false,
  type,
  onKeyDown,
  required,
  min,
}) {
  const inputRef = useRef(null);

  const handleFocus = (e) => {
    if (type === "date" && inputRef.current) {
      try {
        inputRef.current.showPicker();
      } catch (err) {}
    }
    if (onFocus) onFocus(e);
  };

  function handleFocusClick() {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }

  return (
    <div className={classes.container} style={style} onClick={handleFocusClick}>
      <div>
        <label htmlFor={id}>{labelText}</label>{" "}
        {required && <span style={{ color: "red" }}>*</span>}
      </div>

      <input
        ref={inputRef}
        onChange={onChange}
        onClick={handleFocus}
        id={id}
        disabled={disabled}
        onFocus={handleFocus}
        value={value}
        name={name}
        readOnly={readOnly}
        type={type}
        onKeyDown={onKeyDown}
        min={type === "date" ? min : ""}
        step={type === "number" ? "any" : undefined}
      />
    </div>
  );
}
